import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StorageService } from '../storage.service';
import { TipoAccesos } from '../tiendas/accesos';
import { TotemService } from '../totem.service';
import { EventEmitterService } from '../event-emitter.service';
import {  Router } from '@angular/router';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-autocompletar',
  templateUrl: './autocompletar.component.html',
  styleUrls: ['./autocompletar.component.css']
})
export class AutocompletarComponent implements OnInit, OnDestroy {
  @Input()
    tipoInput: string;
  @Input()
    textoBusqueda: string = '';
  @Input()
    parentForm: FormGroup;
  @Input()
    invalid: boolean = false;

  autocompleteLabel: string;
  autocompleteFormControl: string;
  autocompletePlaceholder: string;
  autocompleteTextHelp: string;

  tiendas = [];
  subcategorias = [];
  tiendasSinfiltro = [];
  tiendasCargadas = false;
  autoCompletador = false;

  // 2
  public actual: string = '';
  public subscription;

  constructor(private totemService: TotemService, private localStorage: StorageService,
              private eventEmitterService: EventEmitterService, public router: Router
              ) {
                this.subscription = this.totemService.getLanguage().subscribe(language => {
                  this.actual = language;
                  this.obtenerTiendas();
                });
                  // 3
    // this.actual = this.totemService.actualLanguage;
               }

  ngOnInit() {
    this.autocompleteLabel = this.tipoInput === 'inicio' ? 'dondeEstas' : 'dondeQuieresIr';
    this.autocompleteFormControl = this.tipoInput === 'inicio' ? 'dondeEstas': 'dondeQuieresIr';
    this.autocompletePlaceholder = this.tipoInput === 'inicio' ? 'escribeElNombreDelLugar' :
      'escribeLaTiendaoTiendas';
    this.autocompleteTextHelp = this.tipoInput === 'inicio' ? 'Tienda o tiendas más cercanas' :
      'Nombre del lugar al que quieres ir';
      // 

    this.obtenerTiendas();

    if(this.localStorage.getNodosRuta()){
      this.obtenerEstacionamiento();
      this.obtenerServicios();
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  ManageFooter(manage: any) {
    this.eventEmitterService.activarFooter(manage);
  }

  obtenerEstacionamiento() {
    const datoLocal = this.localStorage.getNodosRuta();
    const tipoLocal = this.tipoInput === 'inicio' ? 'tipoInicio' : 'tipoDestino';
    if (datoLocal[tipoLocal] === 'estacionamiento') {
      const estacionamientoNombre = this.totemService.getEstacionamientoPorID( parseInt(datoLocal[this.tipoInput]) );
      this.parentForm.controls[this.autocompleteFormControl].setValue(`Estacionamiento ${estacionamientoNombre}`);
    }
  }

  async obtenerServicios() {
    try {
      let resultado = await this.totemService.getTipoAccesos().toPromise();
      resultado = resultado.map( tipoAcceso => new TipoAccesos(tipoAcceso));
      const datoLocal = this.localStorage.getNodosRuta();
      const tipoLocal = this.tipoInput === 'inicio' ? 'tipoInicio' : 'tipoDestino';
      let servicioLocal;
      if (datoLocal[tipoLocal] === 'servicios')
        servicioLocal = resultado.find(tipoAcceso => tipoAcceso.id === parseInt(datoLocal[this.tipoInput], 10));
      if (servicioLocal)
        this.parentForm.controls[this.autocompleteFormControl].setValue(servicioLocal.nombre);

      console.log('[SERVICIOS]', resultado);
    } catch (err) {
      console.error(err);
    }
  }

  async obtenerTiendas() {
    try {
      // obtener tiendas
      let resultado = await this.totemService.obtenerTiendasOrdenadas('es');
      resultado = resultado.map(tienda => {
        tienda.nombrePiso = tienda.nombre + ' - Piso ' + tienda.numeroPiso;
        return tienda;
      });

      const datosRuta = this.localStorage.getNodosRuta();
      const tipoLocal = this.tipoInput === 'inicio'? 'tipoInicio': 'tipoDestino';
      let tiendaLS;
      if(!this.localStorage.getNodosRuta()){
        tiendaLS = resultado;
      } else {
        if (datosRuta[tipoLocal] === 'tiendas')
        tiendaLS = resultado.find(tienda => tienda.puntoInteres === parseInt(datosRuta[this.tipoInput], 10));
      }
      
      if (tiendaLS){
        tiendaLS.nombrePiso = this.getTranslationPiso(tiendaLS.nombrePiso);
        this.parentForm.controls[this.autocompleteFormControl].setValue(tiendaLS.nombrePiso);
      }
      

      // obtener categorias
      this.subcategorias = await this.totemService.obtenerCategoriasPorTiendas(this.actual,resultado);

      this.tiendas = this.totemService.sortByKey(resultado);
      this.tiendasSinfiltro = this.tiendas.slice();
      this.tiendasCargadas = true;
      console.log('[TIENDAS]', this.tiendas);
      console.log('[CATEGORIAS]', this.subcategorias);
    } catch (err) {
      console.error(err);
    }
  }

  busqueda(event: any) {
    const textoBusqueda = (event.target as HTMLInputElement).value;
    this.parentForm.controls[this.autocompleteFormControl].setValue(textoBusqueda);
    console.log('[BUSQUEDA]', textoBusqueda);

    this.tiendas = !textoBusqueda || textoBusqueda === '' ?
                       this.tiendasSinfiltro : this.tiendas;
    this.filtrarTiendas(textoBusqueda);
  }

  filtrarTiendas(input: any) {
    input = input.toUpperCase();
    // filtrar que comienzan con la busqueda
    const comienzan = this.tiendasSinfiltro.filter( tienda => {
      const nombreTienda = this.totemService.eliminarDiacriticos(tienda.nombrePiso);
      return nombreTienda.toUpperCase().indexOf(input) === 0;
    });
    // console.log('[COMIENZAN]', comienzan);
    const tiendasFiltradas = this.eliminarFiltrados(this.tiendasSinfiltro, comienzan);
    // filtrar que contienen con la busqueda
    const contienen = tiendasFiltradas.filter(tienda => {
      const nombreTienda = this.totemService.eliminarDiacriticos(tienda.nombrePiso);
      return nombreTienda.toUpperCase().includes(input);
    });

    const arregloTiendas = comienzan.concat(contienen);
    this.tiendas = arregloTiendas;
    console.log('TIENDAS FILTRADAS', this.tiendas);
  }

  eliminarFiltrados(tiendasporfiltrar: any, tiendasfiltradas: any) {
    const nuevalista = tiendasporfiltrar.filter( tienda => {
      return tiendasfiltradas.indexOf(tienda) === -1;
    });
    return nuevalista;
  }

  async seleccionar(tienda) {
    console.log('la tienda', tienda);
    // Defensive check: items (servicios, eventos, estacionamientos o tiendas sin
    // locales asociados) pueden no traer .local o traerlo undefined. Antes se
    // accedia directo a tienda.local.length y rompia la seleccion de origen.
    const localTienda = tienda && tienda.local && tienda.local.length ? tienda.local[0] : null;
    let idTotem = environment.totem; // totem por defecto
    if (localTienda) {
      try {
        const response: any = await this.totemService.getTotemPuntoInteres(localTienda).toPromise();
        const totemTienda = Array.isArray(response) ? response[0] : response;
        console.log('totemTienda', totemTienda);
        idTotem = !!totemTienda ? totemTienda.id_totem : environment.totem;
      } catch (err) {
        console.warn('No se pudo resolver el totem asociado al local, usando default', err);
        idTotem = environment.totem;
      }
    }
    switch (this.tipoInput) {
      case 'inicio':
        tienda.nombrePiso = this.getTranslationPiso(tienda.nombrePiso);
        this.parentForm.controls[this.autocompleteFormControl].setValue(tienda.nombrePiso);
        this.localStorage.setInicio(tienda.puntoInteres, 'tiendas', idTotem);
        // await this.totemService.setTotemConfig(idTotem);
        break;
      case 'destino':
        tienda.nombrePiso = this.getTranslationPiso(tienda.nombrePiso);
        this.parentForm.controls[this.autocompleteFormControl].setValue(tienda.nombrePiso);
        this.localStorage.setDestino(tienda.puntoInteres, 'tiendas');
        break;
    }
  }

  toggleDropDown() {
    setTimeout(() => {
      this.autoCompletador = !this.autoCompletador;
    }, 150);
  }

  // 4
  changeLanguage(language: any) {
    this.actual = language;
    this.totemService.changeLanguage(language);
  }
  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }

  getTranslationPiso(key: string) {
    try{
        let clave =  key ? key.split(' - ') : null;
        const piso = clave ? clave[1].split(' '): null;
        const word = piso ? this.totemService.getTranslation(piso[0].toLocaleLowerCase()) : null;
        if (word && word.length > 0){
          const res = `${clave[0]} - ${word[0].texto_descripcion} ${piso[1]}`;
          return res;
        }
    } catch (err) {
      console.error(err);
    }
  }
  

}
